import axios from 'axios'
import qs from 'qs'
import _ from 'lodash'
import Cookies from '@/until/cookie'

export default (function () {
  let NODE_TEST = process.env.HOST
  console.log('NODE_TEST', NODE_TEST)
  let options = {
    cookieDomain: null,
    refreshPath: '/Api/OAuth/Exchange',
    baseUrl: NODE_TEST === 'test' ? 'https://ssma.echao.com/auction' : 'https://ssma.echao.com/auction'
  }
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  axios.defaults.baseURL = options.baseUrl
  // axios.defaults.timeout = 900000

  axios.interceptors.request.use((config) => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    // console.log(config.method + ':' + config.baseURL, config.data)
    return config
  })
  axios.interceptors.response.use((res) => {
    return res
  })

  function api(path, param, config) {
    return new Promise((resolve) => {
      const query = Object.assign({}, param || {})
      if (!Object.prototype.hasOwnProperty.call(query, 'access_token')) {
        query.access_token = Cookies.get('access_token') || ''
      }
      return axios.post(path, query, Object.assign({}, config || {})).then((res) => {
        // 未登录或登录失效
        if (res.data && res.data.error_code === 300) {
          api.removeCookie()
        }
        resolve(Object.assign({}, res, res.data, {request_query: query}))
      }).catch((err) => {
        resolve({error_code: 404, error_msg: err.message, data: null})
      })
    })
  }

  api.getAccessToken = () => {
    return  Cookies.get('access_token') || ''
  }

  api.setCookie = (token, expires) => {
    const expiresTime = new Date(expires * 1000)
    Cookies.set('access_token', token, {expires: expiresTime, path: '/', domain: options.cookieDomain})
    Cookies.set('access_expires', expires - 600, {expires: expiresTime, path: '/', domain: options.cookieDomain})
    return expiresTime
  }
  api.removeCookie = () => {
    Cookies.remove('access_token', {path: '/', domain: options.cookieDomain})
    Cookies.remove('access_expires', {path: '/', domain: options.cookieDomain})
  }
  api.setOptions = (name, value) => {
    if (_.isPlainObject(name)) {
      options = Object.assign({}, options, name)
    } else if (_.isString(name)) {
      options[name] = value
    }
  }
  api.getOptions = (name) => {
    if (Object.prototype.hasOwnProperty.call(options, name)) {
      return options[name]
    } else if (name === 'access_token') {
      return Cookies.get('access_token') || ''
    }
    return undefined
  }
  api.aliSts = () => {
    return new Promise((resolve) => {
      const currentTime = parseInt((new Date()).getTime() / 1000, 10)
      if (!options.aliSts || !_.isPlainObject(options.aliSts) || options.aliSts.expiration <= currentTime) {
        return api('/Api/AliSts/Token', {}).then((body) => {
          if (body.data && !body.data.error_code) {
            options.aliSts = body.data
          }
          resolve(options.aliSts)
        })
      }
      resolve(options.aliSts)
    })
  }

  api.expires = (expiresTime) => {
    return new Promise((resolve) => {
      const currentTime = parseInt((new Date()).getTime() / 1000, 10)
      const accessToken = Cookies.get('access_token')
      const accessExpires = Cookies.get('access_expires')
      if (!accessToken || !accessExpires || (accessExpires <= currentTime)) {
        api.removeCookie()
        return resolve(false)
      }
      if (accessExpires - (expiresTime || 180) <= currentTime) {
        return api(options.refreshPath, {token: accessToken}).then((refresh) => {
          if (refresh.data && refresh.data.access_token) {
            api.setCookie(refresh.data.access_token, refresh.data.expires_time)
            return resolve(true)
          }
          api.removeCookie()
          return resolve(false)
        })
      }
      return resolve(true)
    })
  }
  return api
})()



// WEBPACK FOOTER //
// ./src/until/core.js